import { render, staticRenderFns } from "./widget-search.vue?vue&type=template&id=110d3ffe&scoped=true&"
import script from "./widget-search.vue?vue&type=script&lang=js&"
export * from "./widget-search.vue?vue&type=script&lang=js&"
import style0 from "./widget-search.vue?vue&type=style&index=0&id=110d3ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110d3ffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VList,VSkeletonLoader,VTextField})
